import React, { useContext } from "react";

import "./Work.css";
import CPP from "../../img/c++.png";
import PY from "../../img/py.png";
import TF from "../../img/tens.png";
import DJ from "../../img/dj.png";
import GCP from "../../img/gcp.png";
import { motion } from "framer-motion";

import { themeContext } from "../../Context";

const Work = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div className="works">
      <div className="awesome">
        <span style={{ color: darkMode ? "white" : "" }}>Skills</span>
        <span > Languages,Framework and Tools</span>
        <span style={{ color: darkMode ? "white" : "" }}>
         <ul classNAme="alpha" style={{marginTop:"2rem"}}>

          <li  style={{marginTop:"2rem",fontSize:"1.5rem"}}>Data Science-Natural Language  Processing,Computer Vision</li>
          <li style={{marginTop:"2rem",fontSize:"1.5rem"}}>Development-Django,FastApi, Flask,CSS,Html</li>
          <li  style={{marginTop:"2rem",fontSize:"1.5rem"}}>Data Structure and Algorithms-C++</li>
          <li style={{marginTop:"2rem",fontSize:"1.5rem"}}>Cloud-AWS,GCP</li>
         </ul>
        </span>
        <div className="blur s-blur1" style={{ background: "#ABF1FF94" }}></div>
      </div>

      <div className="w-right">
        <motion.div
          initial={{ rotate: -40 }}
          whileInView={{ rotate: 360 }}
          viewport={{ margin: "-40px" }}
          transition={{ duration: 3.5, type: "spring" }}
          className="w-mainCircle"
        >
          <div className="w-maincircle">
            <div className="seccircle">
              <img src={TF} alt="tensorflow" />
            </div>

            <div className="seccircle">
              <img src={PY} alt="python" />
            </div>

            <div className="seccircle">
              <img src={CPP} alt="cpp" />
            </div>

            <div className="seccircle">
              <img src={DJ} alt="django" />
            </div>

            <div className="seccircle">
              <img src={GCP} alt="googlecloud" />
            </div>
          </div>

          <div className="w-backcircle red"></div>
          <div className="w-backcircle blue"></div>
        </motion.div>
      </div>
    </div>
  );
};

export default Work;
